const ConsumerErrorId = {
    GENERIC: '000',
    PLAYBACK_INTERRUPTED_CONNECTION_LOST: '005',
    DRM: '012',
    PLAYBACK_SOURCE_STARTUP: '064',
    PLAYBACK_SOURCE_MIDSTREAM: '065',

    API_SERVICE_PLAYBACK_MISSING_PLAYBACK_DETAILS: '066',
    API_SERVICE_PLAYBACK_CONCURRENT_USER_LIMIT: '068',

    BAD_REQUEST: '067',
    NOT_FOUND: '069',
};

export default ConsumerErrorId;
